export const MEMBER_HITOS = `
  query memberHitos(
    $tenant_id: Int!,
    $skip: Int,
    $take: Int,
    $orderBy: MemberHitoOrderInput,
    $filter: FilterMemberHitoInput,
    $searchText: String
  ) {
    memberHitos(
      tenant_id: $tenant_id,
      skip: $skip,
      take: $take,
      orderBy: $orderBy,
      filter: $filter,
      searchText: $searchText
    ) {
      __typename
      ... on MemberHito {
        id
        contact_id
        contact {
          id
          firstname
          lastname
          email
        }
        hito_tipo_id
        hito_tipo {
          id
          name
          code
          category_hito
          icon
          en_timeline
          vigencia_type
          impact_type
        }
        hito_subtipo_id
        hito_subtipo {
          id
          name
        }
        group_id
        group {
          id
          name
        }
        achieved_date
        valid_from
        valid_until
        percentage
        year
        source_type
        request_id
        event_id
        event {
          id
          title
        }
        metadata
        active
        created_by
        its
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const MEMBER_HITO = `
  query memberHito($tenant_id: Int!, $id: Int!) {
    memberHito(tenant_id: $tenant_id, id: $id) {
      __typename
      ... on MemberHito {
        id
        contact_id
        contact {
          id
          firstname
          lastname
          email
        }
        hito_tipo_id
        hito_tipo {
          id
          name
          code
        }
        hito_subtipo_id
        hito_subtipo {
          id
          name
        }
        group_id
        group {
          id
          name
        }
        achieved_date
        valid_from
        valid_until
        percentage
        year
        source_type
        request_id
        event_id
        event {
          id
          title
        }
        metadata
        active
        created_by
        its
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const MEMBER_HITO_COUNT = `
  query memberHitoCount($tenant_id: Int!, $filter: FilterMemberHitoInput, $searchText: String) {
    memberHitoCount(tenant_id: $tenant_id, filter: $filter, searchText: $searchText) {
      __typename
      ... on Count {
        count
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
